import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { OrderProvider } from "./contexts/OrderContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ProduitProvider } from "./contexts/ProduitContext";
import { CategorieProvider } from "./contexts/CategorieContext";
import { FavorisProvider } from "./contexts/FavorisContext";
import PWAInstallPrompt from "./components/feature/PWAInstallPrompt";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <OrderProvider>
            <ProduitProvider>
              <CategorieProvider>
                <FavorisProvider>
                  <AppRoutes />
                  <PWAInstallPrompt />
                </FavorisProvider>
              </CategorieProvider>
            </ProduitProvider>
          </OrderProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;